import React from "react";

const ExportProgress = ({ progress, isExporting, label }) => progress && (
  <div className="mt-3 mb-3">
    <div className="d-flex justify-content-between mb-1" role="status">
      <span>{progress.message}</span>
      <strong className="ml-2">{progress.percent}%</strong>
    </div>
    <div className="progress">
      <div
        className={`progress-bar${isExporting ? " progress-bar-striped progress-bar-animated" : " bg-success"}`}
        role="progressbar"
        aria-label={`${label} export progress`}
        aria-valuenow={progress.percent}
        aria-valuemin={0}
        aria-valuemax={100}
        style={{ width: `${progress.percent}%` }}
      />
    </div>
  </div>
);

export default ExportProgress;
